import { IApplicationState } from '../../types/redux';

export function getDiscountMortgageEnabled(state: IApplicationState) {
  return state.config.isDiscountMortgageEnabled;
}
